import { ChatActionTypes } from './chat.types'

//Send Message
export const chatSendMessageRequest = data => ({
    type: ChatActionTypes.CHAT_SEND_MESSAGE_REQUEST,
    payload: data
})

export const chatSendMessageRequestSuccess = data => ({
    type: ChatActionTypes.CHAT_SEND_MESSAGE_REQUEST_SUCCESS,
    payload: data
})

export const chatSendMessageRequestError = data => ({
    type: ChatActionTypes.CHAT_SEND_MESSAGE_REQUEST_ERROR,
    payload: data
})

export const chatSendMessageRequestStatus = data => ({
    type: ChatActionTypes.CHAT_SEND_MESSAGE_REQUEST_STATUS,
    payload: data
})

//Chat List
export const chatListRequest = data => ({
    type: ChatActionTypes.CHAT_LIST_REQUEST,
    payload: data
})

export const chatListRequestSuccess = data => ({
    type: ChatActionTypes.CHAT_LIST_REQUEST_SUCCESS,
    payload: data
})

export const chatListRequestError = data => ({
    type: ChatActionTypes.CHAT_LIST_REQUEST_ERROR,
    payload: data
})

//Message List
export const messageListRequest = data => ({
    type: ChatActionTypes.MESSAGE_LIST_REQUEST,
    payload: data
})

export const messageListRequestSuccess = data => ({
    type: ChatActionTypes.MESSAGE_LIST_REQUEST_SUCCESS,
    payload: data
})

export const messageListRequestError = data => ({
    type: ChatActionTypes.MESSAGE_LIST_REQUEST_ERROR,
    payload: data
})